var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.member)?_c('MemberAuthorizationManager',{attrs:{"area":_vm.area,"member":_vm.member,"type":"detail"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }